import { useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import loginApi from '../../../api/loginApi'
import { UserResponse } from './types'
import { paths } from '../../../api/pathsApi'
import { handleAxiosError } from '../../../helpers/handleAxiosError'
import { AxiosError } from 'axios'

const getData = async (token: string) => {
  const { data } = await loginApi.get<UserResponse>(paths().USER.INFO, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return data
}

export const useUserMe = (token: string) => {
  const { data, mutate, error, isPending } = useMutation({
    mutationKey: ['userMe'],
    mutationFn: (token: string) => getData(token),
  })

  const handleGetUserInfo = (token: string) => mutate(token)

  useEffect(() => {
    if (token.length > 0) {
      handleGetUserInfo(token)
    }
  }, [token])

  return { userInfo: data, hasError: handleAxiosError(error as AxiosError), isLoading: isPending }
}
